import React from 'react'
import ClassNames from 'classnames'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
//https://github.com/reactjs/react-tabs

import { TabberStyle } from './styled'

export class Tabber extends React.PureComponent {
  static Tab = Tab
  static TabList = TabList
  static TabPanel = TabPanel

  render() {
    return (
      <TabberStyle>
        <Tabs {...this.props} />
      </TabberStyle>
    )
  }
}
